import axios from 'axios';
import { useAdminStore } from '../store/adminStore';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://wellness-mental-app-web-completa.onrender.com/api';

/**
 * Cliente axios del panel Admin. Usa su propio store (adminStore), separado
 * del authStore del paciente, para no pisar la sesión del iframe.
 */
export const adminApiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

const refreshClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

adminApiClient.interceptors.request.use((config) => {
  const { adminToken } = useAdminStore.getState();
  if (adminToken) {
    config.headers.Authorization = `Bearer ${adminToken}`;
  }
  return config;
});

adminApiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;

    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      const { adminRefreshToken, setTokens, logout } = useAdminStore.getState();

      if (adminRefreshToken) {
        try {
          const { data } = await refreshClient.post('/auth/refresh-token', {
            refreshToken: adminRefreshToken,
          });
          setTokens(data.accessToken, adminRefreshToken);
          original.headers.Authorization = `Bearer ${data.accessToken}`;
          return adminApiClient(original);
        } catch {
          logout();
        }
      } else {
        logout();
      }
    }

    return Promise.reject(error);
  },
);
